// extracted by mini-css-extract-plugin
export default {"container":"SettingEmailTemplateList_container__4Uc-H"};